import { render, staticRenderFns } from "./Agenda.vue?vue&type=template&id=341300f4&scoped=true&"
import script from "./Agenda.vue?vue&type=script&lang=ts&"
export * from "./Agenda.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341300f4",
  null
  
)

export default component.exports